import { SETTINGS_INCOMPLETE } from '../pages/Sales/dispatches/dispatchSettingsModel.mjs';
import React from 'react';
import { Link } from 'react-router-dom';
import useNavLabels from './useNavLabels';

const DEEP_MODULES = new Set(['farm-ops', 'inventory', 'finance', 'control-admin', 'purchasing', 'sales']);

// Deep modules (Finance …) put their sections in the LeftMenu, so SubTabs shows the active
// section's own tabs. Shallow modules (Reports …) have no LeftMenu, so their sections render as the
// primary sub-tab row here — AND, when the active section itself has tabs (e.g. Reports › Transactions
// carries the 7 transaction types), those render as a second row so they stay clickable, matching :3000.
export default function SubTabs({ module, section, activeTab }) {
  const nav = useNavLabels();
  const deep = DEEP_MODULES.has(module.key);

  if (deep) {
    const tabs = (section.tabs || []).filter(t => !t.hidden);   // hidden tabs (e.g. GL idlist) stay routable but button-less
    if (!tabs.length) return null;
    return <nav className="subtabs" aria-label={`${nav.sec(module, section)} views`}>
      {tabs.map(tab => <Link key={tab.key} to={`/${module.key}/${section.key}/${tab.key}`}
        className={`subtab${tab.key === activeTab ? ' active' : ''}`}
        aria-current={tab.key === activeTab ? 'page' : undefined}>{nav.tab(module, section, tab)}
        {/* fb-108: a page can portal a red issue-count badge into this slot (e.g. Benchmarks Catalogue/Skeletons). */}
        {tab.chip === 'incomplete' && SETTINGS_INCOMPLETE && <span className="subtab-chip" title={nav.chipTip(tab.chip)} data-testid="subtab-incomplete">{nav.chipText(tab.chip)}</span>}
        <span id={`subtab-badge-${module.key}-${section.key}-${tab.key}`} className="subtab-slot" /></Link>)}
    </nav>;
  }

  // Shallow module: sections are the primary row; the active section's tabs (if any) are a second row.
  const sectionTabs = (section.tabs || []).filter(t => !t.hidden);
  return <>
    <nav className="subtabs subtabs-sections" aria-label={`${nav.mod(module)} sections`}>
      {module.sections.map(s => <Link key={s.key} to={`/${module.key}/${s.key}`}
        className={`subtab${s.key === section.key ? ' active' : ''}`}
        aria-current={s.key === section.key ? 'page' : undefined}>{nav.sec(module, s)}</Link>)}
    </nav>
    {sectionTabs?.length ? (
      <nav className="subtabs subtabs-2" aria-label={`${nav.sec(module, section)} views`}>
        {sectionTabs.map(tab => <Link key={tab.key} to={`/${module.key}/${section.key}/${tab.key}`}
          className={`subtab${tab.key === activeTab ? ' active' : ''}`}
          aria-current={tab.key === activeTab ? 'page' : undefined}>{nav.tab(module, section, tab)}</Link>)}
      </nav>
    ) : null}
  </>;
}
